import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IChungChiGenerateSoHieuRequest } from "../../../model/request/xet-chung-chi/IChungChiGenerateSoHieuRequest";
import { IChungChiGenerateSoVaoSoRequest } from "../../../model/request/xet-chung-chi/IChungChiGenerateSoVaoSoRequest";
import { IChungChiSinhVienUpdateQuyetDinhRequest } from "../../../model/request/xet-chung-chi/IChungChiSinhVienUpdateQuyetDinhRequest";
import { ITongHopChungChiLopRequest } from "../../../model/request/xet-chung-chi/ITongHopChungChiLopRequest";
import { IXetChungChiRequest } from "../../../model/request/xet-chung-chi/IXetChungChiRequest";
import { IChungChiSinhVienKhongDatViewModel } from "../../../model/response/xet-chung-chi/IChungChiSinhVienKhongDatViewModel";
import { IChungChiSinhVienViewModel } from "../../../model/response/xet-chung-chi/IChungChiSinhVienViewModel";
import { ITongHopChungChiLop } from "../../../model/response/xet-chung-chi/ITongHopChungChiLop";
import { ITongHopChungChiResponse } from "../../../model/response/xet-chung-chi/ITongHopChungChiResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChungChiSinhVienActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: {} as IChungChiSinhVienViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",

    LOAD_KHONG_DAT_BY_DOT_XET_START: 0,
    LOAD_KHONG_DAT_BY_DOT_XET_SUCCESS: {} as IChungChiSinhVienKhongDatViewModel[],
    LOAD_KHONG_DAT_BY_DOT_XET_ERROR: "",

    XET_START: {} as IXetChungChiRequest,
    XET_SUCCESS: undefined,
    XET_ERROR: "",

    UPDATE_QUYET_DINH_START: {} as IChungChiSinhVienUpdateQuyetDinhRequest,
    UPDATE_QUYET_DINH_SUCCESS: undefined,
    UPDATE_QUYET_DINH_ERROR: "",

    UPDATE_SO_HIEU_START: {} as IChungChiGenerateSoHieuRequest,
    UPDATE_SO_HIEU_SUCCESS: undefined,
    UPDATE_SO_HIEU_ERROR: "",

    UPDATE_SO_VAO_SO_START: {} as IChungChiGenerateSoVaoSoRequest,
    UPDATE_SO_VAO_SO_SUCCESS: undefined,
    UPDATE_SO_VAO_SO_ERROR: "",

    CLOSE_PROCESSING_MODAL: undefined,


    SHOW_CAU_HINH_SO_VAO_SO_MODAL: undefined,
    CLOSE_CAU_HINH_SO_VAO_SO_MODAL: undefined,

    SHOW_CAU_HINH_SO_HIEU_MODAL: undefined,
    CLOSE_CAU_HINH_SO_HIEU_MODAL: undefined,

    SHOW_CAU_HINH_SO_QUYET_DINH_MODAL: undefined,
    CLOSE_CAU_HINH_SO_QUYET_DINH_MODAL: undefined,

    SINH_VIEN_DU_DIEU_KIEN_CHANGE_SELECTED_IDS: {} as number[],

    SELECT_TONG_HOP_BY_LOP_START: {} as ITongHopChungChiLopRequest,
    SELECT_TONG_HOP_BY_LOP_SUCCESS: {} as ITongHopChungChiResponse,
    SELECT_TONG_HOP_BY_LOP_ERROR: "",

    UPLOAD_MODAL_OPEN: 0,
    UPLOAD_MODAL_CLOSE: undefined,

    CHANGE_FILTER_TONG_HOP_CHUNG_CHI: {} as {
        selectedTrangThaiHocs: number[];
        treeViewLopFocusedValue?: ITreeviewLopFocusedValue | undefined;
    },
}

export const eChungChiSinhVienActionIds = generateActionTypeIds(eChungChiSinhVienActionsObj, "CHUNG_CHI_SINH_VIEN");
export type IChungChiSinhVienActionTypes = IGenericActionType<typeof eChungChiSinhVienActionsObj, "CHUNG_CHI_SINH_VIEN">;